import { URI_GUARD_REQUEST } from '@/config/config';

export default async ({ rootState }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const userToken = rootState['DATA-ACCESS'].userToken;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'user-token': userToken
    },
  };

  let path = `${URI_GUARD_REQUEST}guard-config`;
  const response = await fetch(path, opts);

  const jsonResult = await response.json();

  if (jsonResult.status === 'error') {
    return Promise.reject(jsonResult.message);
  }

  rootState.SERPRO.defaultCondutorSituacao = jsonResult.config.serpro.condutorSituacao;
  rootState.SERPRO.defaultInfracaoCodigo = jsonResult.config.serpro.infracaoCodigo;
  rootState.SERPRO.defaultInfracaoDesdobramento = jsonResult.config.serpro.infracaoDesdobramento;
  rootState.SERPRO.defaultObservacao = jsonResult.config.serpro.observation;
  return jsonResult
};
